export default [
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `"Anyway, you were reading The Diary of a Young Girl. Why Anne Frank?"`,
        speakerTxtRS: `"U svakom slučaju, čitao si Dnevnik Anne Frank. Zašto Anne Frank?"`,
        dialogFx: `assets/dialog/anna/anna0034.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"See, Anna, the diary is the real depiction of life. How life checkmates us, when we are in utter belief that we are winning. It reflects hope through our eyes and pulls it back the moment we are about to grab it."`,
        speakerTxtRS: `"Vidi, Ana, dnevnik je prava slika života. Kako nas život matira, kada smo u potpunom uverenju da pobeđujemo. On reflektuje nadu kroz naše oči i povlači je nazad u trenutku kada smo spremni da je uhvatimo."`,
        dialogFx: `assets/dialog/joseph/joseph0092.mp3`,
    },
    {
        characterImg: `assets/chars/anna/surprisedCasual.webp`,
        speakerTxt: `"On the flip side, it is generous. It gives what you ask for. Anne Frank wanted to be a writer more than freedom. See, she became a best seller when she died. World give. World delivers."`,
        speakerTxtRS: `"S druge strane, on je velikodušan. Daje ono što tražite. Anne Frank je želela da bude pisac više nego sloboda. Vidi, postala je bestseler kada je umrla. Svet daje. Svet isporučuje."`,
        dialogFx: `assets/dialog/joseph/joseph0093.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `"True, so very true."`,
        speakerTxtRS: `"Tačno, tako je."`,
        dialogFx: `assets/dialog/anna/anna0035.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `We continued our dinner in pleasant and lighthearted talk.`,
        speakerTxtRS: `Nastavili smo večeru u prijatnom i veselijem razgovoru.`,
        dialogFx: `assets/dialog/joseph/joseph0094.mp3`
    },
]